import { render, staticRenderFns } from "./PleurisyAttachmentsTable.vue?vue&type=template&id=105b6d42&scoped=true&"
import script from "./PleurisyAttachmentsTable.vue?vue&type=script&lang=ts&"
export * from "./PleurisyAttachmentsTable.vue?vue&type=script&lang=ts&"
import style0 from "./PleurisyAttachmentsTable.vue?vue&type=style&index=0&id=105b6d42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105b6d42",
  null
  
)

export default component.exports